import styled from 'styled-components'

export const FormGroup = styled.div`
  margin-bottom: 20px;
`
